import React, { useState } from 'react';

import BottomSheet from 'components/Common/BottomSheet';
import { useNavigate } from 'hooks/useNavigate';

import DashboardTileCard from './DashboardTileCard';
import DashboardSheetHeader from './DashboardSheetHeader';
import { packTileRows } from './packTileRows';
import { DashboardTileActionType, PackedTile } from './types';
import { useDashboardTiles } from './useDashboardTiles';

import styles from './DashboardActionTiles.module.scss';

const DashboardActionTiles: React.FC = () => {
  const navigate = useNavigate();
  const tiles = useDashboardTiles();
  const rows = packTileRows(tiles);
  const [activeTileId, setActiveTileId] = useState<string | null>(null);

  if (rows.length === 0) return null;

  const activeTile = tiles.find((tile) => tile.id === activeTileId);
  const activeSheet = activeTile?.action.type === DashboardTileActionType.Sheet ? activeTile.action : null;

  const handleTileClick = (tile: PackedTile) => {
    if (tile.analyticsEvent) {
      analytics.track(tile.analyticsEvent);
    }

    if (tile.action.type === DashboardTileActionType.Navigate) {
      navigate(tile.action.path);
      return;
    }

    setActiveTileId(tile.id);
  };

  return (
    <>
      <div className={styles.section}>
        <p className={styles.sectionLabel}>Your dashboard</p>
        <div className={styles.container}>
          {rows.map((row) => (
            <div key={row.map((tile) => tile.id).join('-')} className={styles.row}>
              {row.map((tile) => (
                <DashboardTileCard
                  key={tile.id}
                  highlight={tile.highlight}
                  isFull={tile.isFull}
                  title={tile.title}
                  description={tile.description}
                  icon={tile.icon}
                  iconTone={tile.iconTone}
                  onClick={() => handleTileClick(tile)}
                />
              ))}
            </div>
          ))}
        </div>
      </div>

      <BottomSheet isOpen={Boolean(activeSheet)} onClose={() => setActiveTileId(null)}>
        {activeTile && activeSheet && (
          <>
            <DashboardSheetHeader title={activeTile.title} icon={activeTile.icon} iconTone={activeTile.iconTone} />
            {activeSheet.render(() => setActiveTileId(null))}
          </>
        )}
      </BottomSheet>
    </>
  );
};

export default DashboardActionTiles;
